export default {
	NATIONAL_ACCOUNTS: 'companies/:company_id/settings/national_accounts',
	GET_NATIONAL_ACCOUNT: 'companies/:company_id/national_accounts/',
	NATIONAL_ACCOUNTS_SQM_TIER: 'companies/:company_id/national_accounts/national_account_sqm_tier',
	NATIONAL_ACCOUNTS_SQM_TIER_LIST: 'companies/:company_id/national_accounts/national_account_sqm_tier/list',
}